<form [formGroup]="group" id="chipFullWidthCOMP-form">
  <mat-form-field id="chipFullWidthCOMP-form-mat" class="custom-form-field" style="width: 100%">
    <mat-chip-grid
      [formControlName]="field.name"
      id="chipFullWidthCOMP-form-chip-list"
      #chipList
      aria-label="Chips selection"
    >
      @for (chip of chips; track chip) {
        <mat-chip-row
          id="chipFullWidthCOMP-form-chip"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(chip)"
          [value]="chip.key"
        >
          {{ chip.value }}
          @if (removable) {
            <mat-icon
              id="chipFullWidthCOMP-form-icon"
              matChipRemove
              (click)="remove(chip)"
              (keyup.enter)="remove(chip)"
              tabindex="0"
              >cancel</mat-icon
            >
          }
        </mat-chip-row>
      }
      <input
        matInput
        placeholder="{{ field.displayName }}{{ this.field?.isRequired ? ' *' : '' }}"
        #chipInput
        [formControl]="chipCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="addAutoComplete($event)"
        [name]="field.name"
        [required]="field?.isRequired"
      />
    </mat-chip-grid>

    <mat-autocomplete id="chipFullWidthCOMP-form-auto" #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (chip of filteredChips; track chip) {
        <mat-option [id]="chip.value" [value]="chip.value" matTooltip="{{ chip.value }}">
          {{ chip.value }}
        </mat-option>
      }
    </mat-autocomplete>

    @for (validation of field.validations; track validation) {
      <ng-container id="chipFullWidthCOMP-ng-container" ngProjectAs="mat-error">
        @if (group.get(field.name).hasError(validation.name)) {
          <mat-error id="chipFullWidthCOMP-form-error{{ field.name }}"> {{ validation.message }} </mat-error>
        }
      </ng-container>
    }
  </mat-form-field>
</form>
